<template>
  <div class="ts-h-64 ts-overflow-y-scroll">
    <table class="ts-w-full">
      <thead>
        <tr>
          <th
            class="ts-sticky ts-top-0 ts-z-10 ts-uppercase ts-bg-gray-100 ts-p-2 ts-w-1"
          >
            {{ $t('no') }}
          </th>
          <th
            class="ts-sticky ts-top-0 ts-z-10 ts-uppercase ts-bg-gray-100 ts-p-2"
          >
            {{ $t('visitation.duration') }}
          </th>
          <th
            class="ts-sticky ts-top-0 ts-z-10 ts-uppercase ts-bg-gray-100 ts-p-2"
          >
            {{ $t('visitation.shopName') }}
          </th>
          <th
            class="ts-sticky ts-top-0 ts-z-10 ts-uppercase ts-bg-gray-100 ts-p-2"
          >
            {{ $t('visitation.province') }}
          </th>
          <th
            class="ts-sticky ts-top-0 ts-z-10 ts-uppercase ts-bg-gray-100 ts-p-2"
          >
            {{ $t('visitation.district') }}
          </th>
          <th
            class="ts-sticky ts-top-0 ts-z-10 ts-uppercase ts-bg-gray-100 ts-p-2"
          >
            {{ $t('visitation.commune') }}
          </th>
          <!-- <th
            class="ts-sticky ts-top-0 ts-z-10 ts-uppercase ts-bg-gray-100 ts-p-2"
          >
            {{ $t('visitation.status') }}
          </th> -->
          <th
            class="ts-sticky ts-top-0 ts-z-10 ts-uppercase ts-bg-gray-100 ts-p-2 ts-w-6 ts-whitespace-no-wrap"
          >
            {{ $t('actions') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(i, index) in model.customer_list" :key="index" class="ts-border-b">
          <td class="ts-p-2">{{ index + 1 }}</td>
          <td class="ts-p-1">
            <select
							v-model="i.duration_in_minute"
						>
              <option :value="30">30 minute</option>
              <option :value="60">60 minute</option>
              <option :value="90">90 minute</option>
              <option :value="120">120 minute</option>
              <option :value="150">150 minute</option>
              <option :value="180">180 minute</option>
            </select>
          </td>
					<td>{{ i.customer_name }}</td>
					<td>{{ i.pname }}</td>
					<td>{{ i.dname }}</td>
					<td>{{ i.cname }}</td>
					<td class="ts-text-center">
              <a href="#"
								@click.prevent="onDelete(index)"
							>
                <i class="fa fa-trash text-red"></i>
              </a>
					</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'tableView',
  props: ['value'],
  data() {
    return {
      model: {}
    }
  },
	created () {
		this.model = this.value;
	},
	methods: {
		onDelete(index) {
			this.model.customer_list.splice(index, 1)
		}
	},
}
</script>
